import React, { useState } from 'react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '../UI/sheet';
import { Button } from '../ui/button';
import FilterIcon from '../../assets/icons/filter.svg';
import { LucideX } from 'lucide-react';
import Filter from '../filter/Filter';
import { Label } from '../ui/label';

type FiltersDrawerProps = {
  isMobile: boolean;
  disabled: boolean;
  onApply(): void;
  onResetAll(): void;
  filters: any[];
  activeFilters: number;
  isFiltersActivate: boolean;
};

const FiltersDrawer = (props: FiltersDrawerProps) => {
  const { isMobile, disabled = false, onApply, onResetAll, filters, activeFilters, isFiltersActivate } = props;

  const [open, setOpen] = useState<boolean>(false);

  const handleOnApply = () => {
    onApply();
    setOpen(false);
  };

  const handleOnResetAll = () => {
    onResetAll();
  };

  const handleShowSheet = (val: any) => {
    setOpen(val);
    if (!val) {
      onApply();
    }
  };

  return (
    <Sheet open={open} onOpenChange={(val) => handleShowSheet(val)}>
      <SheetTrigger>
        <Button className={`font-medium ${activeFilters ? '!bg-primary/5 !text-primary !border-primary !border-2' : ''}`} type="button" variant={'outline'}>
          <FilterIcon stroke={activeFilters ? '#3B97B1' : 'black'} />
          Filters
          {activeFilters ? (
            <span className="ml-1 bg-primary text-primary-foreground text-xs rounded-full px-1.5 py-0.5 min-w-[18px]">
              {activeFilters}
            </span>
          ) : null}
        </Button>
      </SheetTrigger>
      <SheetContent noOverlay side="bottom">
        <SheetHeader>
          <SheetTitle>Filters</SheetTitle>
          {activeFilters ? (
            <SheetDescription>{activeFilters} filter applied</SheetDescription>
          ) : null}
        </SheetHeader>

        <div className="p-4 space-y-4">
          <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
            {filters &&
              filters?.length > 0 &&
              filters?.map((f, i) => {
                let f_props = {
                  ...f,
                  isMobile: isMobile,
                };
                return (
                  <div className="w-full flex flex-col gap-2" key={i}>
                    <Label>{f?.filter_name}</Label>
                    <Filter {...f_props} />
                  </div>
                );
              })}
          </div>
        </div>

        <SheetFooter>
          <Button
            onClick={handleOnResetAll}
            disabled={disabled || !isFiltersActivate}
            className="leading-normal flex-1 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 font-medium"
            variant="outline"
          >
            <LucideX />
            Clear All
          </Button>
          <Button onClick={handleOnApply} disabled={disabled} className="flex-1" type="button">
            Apply Filters
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default FiltersDrawer;
